import { Pipe, PipeTransform } from '@angular/core';

import * as moment from 'moment';

@Pipe({ name: 'formatdatepipe' })
export class FormatDatePipe implements PipeTransform {
    transform(date: Date): string {
        return moment(date).format('L');
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/format-date.pipe.ts